import { PygGrupo, PygData } from "./models";

/**
 * Dashboard entity representing dashboard data
 */
export class Dashboard {
  title: string;
  message: string;
  dashboardData: any;
  pygGrupos?: PygGrupo[];
  pygData?: PygData[];

  constructor(
    title: string = 'Dashboard',
    message: string = 'Este es el Dashboard',
    dashboardData: any = null,
    pygGrupos?: PygGrupo[],
    pygData?: PygData[]
  ) {
    this.title = title;
    this.message = message;
    this.dashboardData = dashboardData;
    this.pygGrupos = pygGrupos;
    this.pygData = pygData;
  }

  toPrimitive() {
    return {
      title: this.title,
      message: this.message,
      dashboardData: this.dashboardData,
      pygGrupos: this.pygGrupos,
      pygData: this.pygData
    };
  }

  clone() {
    return new Dashboard(
      this.title,
      this.message,
      this.dashboardData,
      this.pygGrupos,
      this.pygData
    );
  }
}